import { useEffect } from "react";

import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";

import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import MyAuditingPerformanceForm from "./my-auditing-performance-form";
import MyAuditingPerformanceData from "./my-auditing-performance-data";

const MyAuditingPerformance = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_MY_AUDITING_PERFORMANCE",
      "AUDITOR_MY_AUDITING_PERFORMANCE"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("MY_AUDITING_PERFORMANCE")}
        subTitle={i18n.get("CONTROL_PANEL")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <MyAuditingPerformanceForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <MyAuditingPerformanceData />
    </ET3PageDiv>
  );
});
export default MyAuditingPerformance;
